import Icon from '@forwardflow/ui/Icons'

import { Dispatch, SetStateAction, useMemo } from 'react'
import { useGetCallTranscript } from '@forwardflow/hooks/customHooks/conversation/'
import dayjs from 'dayjs'
import { CallSummaryLeadMessageItem } from './CallSummaryLeadMessageItem'
import { CallSummaryAgentMessageItem } from './CallSummaryAgentMessageItem'
interface CallSummaryExpandItemProps {
   setIsExpanded: Dispatch<SetStateAction<boolean>>
   id: number
   selectedLeadDetails: any
   item: any
}
export const CallSummaryExpandItem: React.FC<CallSummaryExpandItemProps> = ({
   setIsExpanded,
   id,
   selectedLeadDetails,
   item
}) => {
   const isDemoLead = useMemo(
      () => window.location.pathname.includes('demo-conversations')
         && !window.location.pathname.includes('demo-conversations-old'),
      []
   )

   const { data: callTranscriptApi } = useGetCallTranscript(id)

   const callTranscript = useMemo(() => {
      return isDemoLead ? item?.conversation : callTranscriptApi
   }, [isDemoLead, item?.conversation, callTranscriptApi])

   return (
      <div className="w-full bg-white/10">
         <div
            className="flex items-center justify-between px-8 py-5 cursor-pointer"
            onClick={() => setIsExpanded(false)}
         >
            <Icon name="arrow-down" className="ml-auto rotate-180" />
         </div>
         <div className="flex flex-col px-8 mb-8 gap-y-4 scroll-px-28">
            {callTranscript?.map((item: any, index: number) => {
               if (item.itemType === 'event') {
                  return (
                     <div
                        key={(item.ts, index)}
                        className="flex items-center justify-between gap-x-5 mx-auto bg-[#2D2E32] px-6 py-1 rounded-full "
                     >
                        <p className="text-[14px]">{item.content}</p>
                        <p className="text-white/70 text-[10px]">
                           {dayjs(item.ts).format('h:mm A, D MMM YYYY')}
                        </p>
                     </div>
                  )
               } else if (item.itemType === 'conversation' && item.isIncoming) {
                  return (
                     <CallSummaryLeadMessageItem
                        key={(item.ts, index)}
                        data={item}
                        selectedLeadDetails={selectedLeadDetails}
                     />
                  )
               } else if (
                  item.itemType === 'conversation' &&
                  !item.isIncoming
               ) {
                  return (
                     <CallSummaryAgentMessageItem
                        key={(item.ts, index)}
                        data={item}
                     />
                  )
               }
            })}
         </div>
      </div>
   )
}
